import { render, staticRenderFns } from "./image-with-text-basic.vue?vue&type=template&id=607c3213&scoped=true&"
import script from "./image-with-text-basic.vue?vue&type=script&lang=js&"
export * from "./image-with-text-basic.vue?vue&type=script&lang=js&"
import style0 from "./image-with-text-basic.vue?vue&type=style&index=0&id=607c3213&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607c3213",
  null
  
)

export default component.exports